// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class UserSetting {
  readonly key: Enums.UserSettingKey;
  readonly value: string;

  constructor(data: { [key: string]: any } = {}) {
    this.key = data.key === undefined ? Enums.UserSettingKey.UserTourMobile : data.key;
    this.value = data.value === undefined ? '' : data.value;
  }

  static zero(): UserSetting {
    const zeroValues: ExcludeMethodsDeep<UserSetting> = {
      key: Enums.UserSettingKey.UserTourMobile,
      value: '',
    };
    return new UserSetting(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UserSettingWireFormat = {
  key: string;
  value: string;
};

type NewUserSettingProps = PartialDeep<UserSetting, { recurseIntoArrays: true }>;
export const NewUserSetting: (props: NewUserSettingProps) => UserSetting = (props) =>
  new UserSetting(props);

type NewUserSettingFromWireFormatProps = PartialDeep<
  UserSettingWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUserSettingFromWireFormat: (
  props: NewUserSettingFromWireFormatProps,
) => UserSetting = (props) => new UserSetting(props);
